export const notaSelecionadaProvider = Symbol("notaSelecionada");
export const comentarioProvider = Symbol("comentario");
export const campanhaInfoProvider = Symbol("campanhaInfo");
export const tipoDoProdutoInfoProvider = Symbol("tipoProdutoInfo");

export interface ICampanhaNPSParams {
  nomeCampanha: string;
  tipoCampanha: number;
  campanhaId: string;
  nomeDoGrupo: string | null;
}

export enum ETipoProduto {
  financas = 1,
  contabil = 2
}

export enum IStorageKeyStatus {
  visualizado = "Visualizado",
  respondido = "Respondido"
}

export enum EStepsPesquisa {
  escolherNota = 1,
  escreverComentario = 2,
  acaoPosResposta = 3,
  finalizar = 4
}

export enum ECategoriaNps {
  detrator = "detrator",
  neutro = "neutro",
  promotor = "promotor"
}

export const obterCategoriaNps = (
  nota: number | undefined
): ECategoriaNps | undefined => {
  if (nota == undefined) return undefined;
  if (nota <= 6) return ECategoriaNps.detrator;
  if (nota <= 8) return ECategoriaNps.neutro;

  return ECategoriaNps.promotor;
};

export const LINKS_PROMOTOR = {
  indicacao:
    "https://f360.com.br/indique/?utm_source=nps&utm_medium=f360_financas&utm_campaign=pesquisa-nps",
  avaliacaoGoogle: "https://g.page/r/CQ7BzR1MqU7HEBM/review"
};

export interface ICampanhaProps {
  campanhaId: string;
  nomeDoGrupo: string;
  tipoCampanha: number;
  exibirCampanha: boolean;
}
